<template>

<core-dropdown trigger="manual" v-on:forceClose="is.expanded = false" :expanded="is.expanded" v-click-outside="onOutsideClick">

	<core-button v-on:click.native="onToggleClick" tooltip="Tags" :caret="true" theme="filter" icon="tags" :iconOnly="$isDesktop" v-if="!hideButton" :icon-left="$isMobile" :text="text" />

	<div v-if="totalFilterCount" class="tags-count">{{ totalFilterCount }}</div>
	
	<portal to="mobileactions" v-if="$isMobile && $route.meta.hasActions">

		<core-button 
			v-on:click.native="onToggleClick" 
			theme="filter" 
			icon="tags" 
			:icon-left="true" 
			text="Tags" 
			v-if="$isSelf || totalTags"
			:count="totalFilterCount"
		/>
	
	</portal>

	<core-dropdown-list title="Tags" class="tags-dropdown" :expanded="is.expanded" theme="filter" :caret="true" align="right" type="button" v-propagation v-on:close="is.expanded = false">

		<core-dropdown-level parent="root" name="family" v-if="is.family" v-on:level="is.family = false">

			<div class="tags no-search">

			<template v-for="item in familyTags">

				<com-tag :tag="item" :key="item.id" v-on:click="onTagClick(item.id)" />

			</template>

			</div>

			<core-dropdown-item type="divide" v-if="familyTags.length > 1" />

			<core-dropdown-item type="link" :is-ticked="isFamilyFiltered" v-on:click.native.stop="onFamilyAllClick">Any tag in family</core-dropdown-item>

		</core-dropdown-level>

		<core-dropdown-level name="root" v-if="!is.family">
		
			<template v-if="totalTags">

				<input type="text" ref="search" v-model="search" class="tag-search" placeholder="Quick filter tags..." v-if="totalTags >= 8" />

				<div class="tags" :class="{'is-self': $isSelf, 'no-search': totalTags < 8}" v-if="availableTags.length || filteredTags.length">

					<com-tag :tag="tag" v-for="tag in filteredTags" :key="tag.id" :selected="true" v-on:click="onTagClick(tag.id)" />

					<core-dropdown-item type="divide" v-if="filteredTags.length && availableTags.length" key="divide" />

					<template v-for="item in availableTags">

						<com-tag :tag="item" :key="item.id" v-on:click="onTagClick(item.id)" v-if="item.isTag" />
						<com-family :family="item" :key="item.id" v-on:click="onFamilyClick(item.id)" v-if="item.isFamily" />

					</template>

				</div>

			</template>

			<core-dropdown-item type="text" class="is-empty" v-if="!totalTags && !$isSelf">No tags created.</core-dropdown-item>

			<template v-if="$isSelf">

				<core-dropdown-item type="divide" v-if="totalTags" />

				<core-dropdown-item type="link" v-on:click.native.stop="onCreateClick">Create tag</core-dropdown-item>
				<core-dropdown-item type="link" v-on:click.native.stop="onManageClick">Manage tags</core-dropdown-item>

			</template>

		</core-dropdown-level>

	</core-dropdown-list>

</core-dropdown>

</template>

<script>

import vClickOutside from 'v-click-outside'

import comTag from './tags/Tag'
import comFamily from './tags/Family'

export default {

	directives: {
		clickOutside: vClickOutside.directive
	},

	props: ['hideButton', 'type'],

	components: {
		comTag,
		comFamily
	},

	data: function() {

		return {

			search: '',

			is: {
				family: false,
				expanded: false
			}

		}

	},

	computed: {

		text: function() {

			return 'Tags'

		},

		totalFilterCount: function() {

			return this.$store.getters['filter/' + this.type + '/tags'].length + this.$store.getters['filter/' + this.type + '/tagfamilies'].length

		},

		totalTags: function() {

			return this.items.length

		},

		tags: function() {

			return this.$_.filter(this.$store.getters['data/tags/list'], function(tag) {

				return !tag.family

			})

		},

		families: function() {

			return this.$store.getters['data/tagFamilies/list']

		},

		items: function() {

			var items = []

			this.$_.each(this.tags, function(tag) {

				tag = this.$util.copy(tag)
				tag.sort = tag.text
				tag.isTag = true

				items.push(tag)

			}.bind(this))

			this.$_.each(this.families, function(family) {

				var tags = this.$_.filter(this.$store.getters['data/tags/list'], function(tag) {

					return tag.family === family.id && !this.$_.contains(this.$store.getters['filter/' + this.type + '/tags/absolute'], tag.id)

				}.bind(this))

				if (tags.length) {

					family = this.$util.copy(family)
					family.sort = family.name
					family.isFamily = true

					items.push(family)

				}

			}.bind(this))

			items = this.$_.sortBy(items, function(item) {

				return item.sort.toLowerCase()

			})

			return items

		},

		filteredTags: function() {

			if (!this.totalFilterCount) return []

			return this.$_.filter(this.$store.getters['data/tags/list'], function(tag) {

				return this.$_.contains(this.$store.getters['filter/' + this.type + '/tags/absolute'], tag.id)

			}.bind(this))

		},

		availableTags: function() {

			var items = this.items

			if (this.totalFilterCount) {

				items = this.$_.filter(items, function(item) {

					if (item.isTag) {

						return !this.$_.contains(this.$store.getters['filter/' + this.type + '/tags/absolute'], item.id)
						
					} else {

						return true

					}

				}.bind(this))

			}

			if (!this.search) return items

			return this.$_.filter(items, function(item) {

				return item.sort.indexOf(this.search.toLowerCase()) >= 0

			}.bind(this))

		},

		familyTags: function() {

			return this.$_.filter(this.$store.getters['data/tags/list'], function(tag) {

				return tag.family === this.is.family && !this.$_.contains(this.$store.getters['filter/' + this.type + '/tags/absolute'], tag.id)

			}.bind(this))

		},

		isFamilyFiltered: function() {

			return this.$_.contains(this.$store.getters['filter/' + this.type + '/tagfamilies'], this.is.family.toString())

		}

	},

	methods: {

		onFamilyAllClick: function() {

			if(this.isFamilyFiltered) {

				this.$store.commit('filter/' + this.type + '/tagfamilies', {
					id: this.is.family
				})

			} else {

				this.$store.commit('filter/' + this.type + '/tagfamilies', {
					value: this.is.family
				})

			}

		},

		onFamilyClick: function(value) {

			this.is.family = value

		},

		onTagClick: function(value) {

			if (this.$_.contains(this.$store.getters['filter/' + this.type + '/tags/absolute'], value)) {

				this.$store.commit('filter/' + this.type + '/tags', {
					id: value
				})

			} else {

				this.$store.commit('filter/' + this.type + '/tags', {
					value: value
				})

				if(this.is.family) {

					var family = this.$_.find(this.$store.getters['data/tagFamilies/list'], function(family) {

						return family.id === this.is.family

					}.bind(this))

					if (family.type) {

						this.$_.each(this.$store.getters['data/tags/list'], function(tag) {

							if(tag.family === this.is.family && tag.id !== value && this.$_.contains(this.$store.getters['filter/coll' + this.type + 'ection/tags/absolute'], tag.id)) {

								this.$store.commit('filter/' + this.type + '/tags', {
									id: tag.id
								})

							}

						}.bind(this))

					}

				}

			}

			this.is.family = false
			this.is.expanded = false

		},

		onCreateClick: function() {

			this.$pubsub.$emit('open.modal', 'tagCreate')

			this.is.expanded = false

		},

		onManageClick: function() {

			this.$pubsub.$emit('open.modal', 'tagManage')

			this.is.expanded = false

		},

		onToggleClick: function() {

			this.is.expanded = !this.is.expanded

			if (this.is.expanded && this.totalTags) {

				this.$nextTick(function() {
					
					if(this.$refs.search) this.$refs.search.focus()

				}.bind(this))

			}

		},

		onOutsideClick: function() {

			this.is.expanded = false
			this.is.family = false

		}

	}

}

</script>

<style scoped>

/*
.tags-dropdown >>> .dropdown-item.type-divide {
	background-color: #426a80!important;
}

.tags-dropdown >>> .dropdown-item.type-title {
	padding: 5px 10px;
	font-weight: 300;
	opacity: 0.7;
	font-size: 12px;
	font-family: 'Roboto', sans-serif;
}

.tags-dropdown >>> .dropdown-item.type-link {
	padding: 5px 10px;
	font-weight: 400;
	font-family: 'Roboto', sans-serif;
}

.tags-dropdown >>> .dropdown-item:first-child {
	border-top: 0px;
}

.tags-dropdown >>> .dropdown-item.type-link:hover {
	background-color: rgba(0, 0, 0, 0.15);
}
*/

.tags {
	margin-top: 10px;
	display: grid;
	grid-template-columns: 1fr;
	max-height: 276px;
	overflow: auto;
}

.tags.is-self {
	margin-bottom: 5px;
}

.tags.no-search {
	margin-top: 0px;
}

.tag-search {
	background-color: #fff;
	border-radius: 4px;
	height: 24px;
	font-size: 14px;
	margin: 5px 10px 0px 10px;
	width: calc(100% - 20px);
	padding: 0px 5px;
}

.tags-item {
	font-size: 14px;
    color: #fff;
	height: 24px;
	margin: 0px 10px;
	line-height: 24px;
    padding: 0px 5px;
    border-radius: 4px;
	user-select: none;
    cursor: pointer;
    font-weight: 400;
    display: flex;
	cursor: pointer;
    flex-direction: row;
}

.tags-item .fa {
	position: absolute;
	right: 5px;
	top: 0px;
	line-height: 24px;
	color: rgba(255, 255, 255, 0.5);
}

.tags-item:hover {
	filter: brightness(125%);
}

.tags-item:hover .fa {
	color: #fff;
}

.tags-count {
	position: absolute;
	right: -6px;
	top: -6px;
	z-index: 1;
	background-color: #ffc563;
	border-radius: 4px;
	color: #333;
	font-size: 12px;
	min-width: 16px;
	height: 16px;
	padding: 0px 4px;
	text-align: center;
	font-weight: 500;
	line-height: 16px;
}

.is-mobile .tags-count {
	right: 10px;
	top: 50%;
	margin-top: -8px;
}

</style>
